import { render } from "./edit.vue?vue&type=template&id=fb778876&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=fb778876&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb778876"],['__file',"src/views/chess/room/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb778876"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb778876', __exports__)) {
    console.log('reload')
    api.reload('fb778876', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=fb778876&scoped=true", () => {
    console.log('re-render')
    api.rerender('fb778876', render)
  })

}


export default __exports__